import { Box, IconButton,  TextField, Typography, getContrastRatio } from "@mui/material";
import { useEffect, useState } from "react";
import CustomAlert from "../../events/components/CustomAlert"
import { useDispatch, useSelector } from "react-redux";
import CheckIcon from "../../../components/icons/CheckIcon";
import { useNavigate } from "react-router-dom";
import { generateLighterContrastColor } from "../../../utils/commonServices";
import useCustomTheme from "../../../theme/useCustomTheme";
import { updateProjectState } from "../../../redux/projectSlice";
// import {  getAllEventSongs, updateEventSongText } from "../actions";
// import useSequentialSongUpload from "../hooks/useSequentialSongUpload";
// import SongDropzone from "./SongDropzone";
import UploadedSongsTable from "./UploadedSongsTable";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CustomTooltip from "../../../components/CustomTooltip";

const ViewSongsPopup = () => {

   
      const dispatch = useDispatch()
      const navigate = useNavigate()
      const commonReducer = useSelector((state) => state.root.commonReducer);
      const dropdownReducer = useSelector((state) => state.root.dropdownReducer);
      const projectReducer = useSelector((state) => state.projectReducer);
      const [uploadedSongs , setUploadedSongs] = useState (projectReducer?.event_details?.event_songs)
     
      const [theme] = useCustomTheme()
      const [editMode, setEditMode] = useState(false)
      const [songType, setSongType] = useState(commonReducer?.project_details?.song_type)
      const [disableUpload, setDisableUpload] = useState(false)

      // const { files, 
      //     setFiles,
      //     progress, 
      //     uploadStatus,
      //     setUploadStatus, 
      //     setProgress,
      //     isLoading,
      //     requestController, 
      //     setRequestController,
      //     stopUpload, 
      //     stopList ,
      //     enableFileUpload,
      //     isDisabled,
      //     setIsDisabled,
      //     setEnableFileUpload} = useSequentialSongUpload(commonReducer?.production_event_id , false, uploadedSongs,  ()=>afterUploadCallback()) 
     
   
  
      const handleClose = () => {
        // if(isLoading === true){
        //   stopList( ()=> dispatch(updateProjectState({upload_song_popup : false}))  )
        // }else{
          dispatch(updateProjectState({uploaded_songs_popup : false}))      
        // }
      
      };

      // const handleFocus = (event) => {
      //   const length = event.target.value?.trim()?.length;
      //   event.target.setSelectionRange(length, length);
      // };
  
      
    // const saveSongText =()=>{
    //   const payload = {
    //     id: commonReducer?.production_event_id,
    //     song_type: songType
    //   }
    //   console.log({payload})
    //   updateEventSongText(payload, dispatch, convertToViewMode)
    // }
    
    // useEffect(()=> {
    //   getAllEventSongs({event_id: commonReducer?.production_event_id}, dispatch) 
    // }, [])
  
    useEffect(() => {
       setUploadedSongs(projectReducer?.project_details?.event_songs)
  
    }, [ projectReducer?.project_details?.event_songs])
  
    // const afterUploadCallback =()=>{
      
    //   getAllEventSongs({event_id: commonReducer?.production_event_id}, dispatch, getEventSongsCallback) 
    // }

    // const getEventSongsCallback =()=>{
    //   setIsDisabled(false)
    // }

   

    // const convertToViewMode = ()=>{
    //   setEditMode(false)
    // }

    // const convertToEditMode = ()=>{
    //   setEditMode(true)
    // }



    // useEffect(() => {
    //   const handleKeyDown = (e) => {
    //     e.stopPropagation(); 
    //     if (e.key === ' ' || e.key === 'f' || e.key ===  'arrowright' || e.key === 'k'  || e.key === 'm'  || e.key === 'arrowleft') {
    //       // e.preventDefault(); 
    //     }
    //   };
  
    //   if (projectReducer.upload_song_popup) {
    //     document.addEventListener('keydown', handleKeyDown, true);
    //   }
  
    //   return () => {
    //     document.removeEventListener('keydown', handleKeyDown, true);
    //   };
    // }, [projectReducer.upload_song_popup]);
  
  

  return (
    <CustomAlert 
      open={projectReducer.uploaded_songs_popup} 
      handleClose={handleClose} 
      height={{xs:'550px',md:'550px',lg:'560px' ,xl:'770px'}}
      // height={{xs:'550px',md:'610px',lg:'605px' ,xl:'700px'}}
      width={{xs:'600px',md:'740px',lg:'780px',xl:'1170px'}}
      >       
        <Box sx={{display:'flex', flexDirection:'column', height:'100%', }} px={4} pt={1} pb={2}>
          <Box flexGrow={1} pt={{xs:3,sm:1, md:1.5, lg:2.5, xl:3}} sx={{overflowY:'hidden'}} >    
             
              <Box className='flex col' gap={{xs:0.5, lg:1}}  sx={{ height:'100%', }}>
                <Box className='flex j-between a-center' style={{width:{xs:'90%', md:'80%'}}}>
                  <Typography sx={{fontWeight:600, fontFamily:'Rubik', color:'#000', fontSize:{xs:'14px',sm:'14px',md:'16px',lg:'20px',xl:'30px'}}}>My Music</Typography>   
                </Box>

      
                 
              {/* {   ((commonReducer?.event_details?.status_type_order < 3 || ( commonReducer.event_details?.revision?.submitted == false && commonReducer.event_details?.final_video_id == commonReducer.event_details?.revision?.revision_video_id)) && !editMode) &&    <Box  sx={{height:'100px', width: '90%' , minWidth: '320px', marginTop:{xs: '20px', md: '10px'}, marginBottom:{xs:'10px', sm:'15px',md:'5px',lg:'25px', xl:'70px'}, ml:1}}>
                    <SongDropzone
                    flex='row'
                     isDisabled={
                         isLoading 
                       }
                     files={files}
                     setFiles={setFiles}
                     setUploadStatus={setUploadStatus}
                     setProgress={setProgress}
                     setRequestController={setRequestController}
                    //  height={{xs: '80px',sm:'75px',md:'85px',lg:'105px', xl:'140px'}}
                     height={{xs: '90px',sm:'85px',md:'85px',lg:'115px', xl:'150px'}}
                     setEnableFileUpload={setEnableFileUpload}
                     
                   />
                   <Box className='flex row j-end ' gap={0.5} sx={{alignItems: 'flex-end'}} >
                    <Typography textAlign={"end"} sx={{fontSize: {xs:'9px',md:'10px',lg:'11px',xl:'15px'}, fontWeight:600, mt:'3px'}}>Audio files upto 500 mb.</Typography>
                    <CustomTooltip title=" Files Allowed: .wav, .ogg, .flac, .mp3, .mp4, .m4a, .aiff, .caf, .aac " >
                      <InfoOutlinedIcon sx={{fontSize:  {xs:'9px !important',md:'9px !important',lg:'10.67px !important', xl:'16px !important'}, color: '#000000',  marginBottom: '2px'}} />
                    </CustomTooltip>
                   </Box>
                  
                    </Box>} */}

                    
                    <Box height= '100%'  className= 'flex row j-between a-start' sx={{width:'100%', }}>
                  

                      <Box pl={1} component='div'  sx={{  maxHeight: {xs: '130px', sm: '120px', md: '210px', lg: '150px', xl: '215px'} ,  maxWidth:'85%', width:'85%'}}>

                        <UploadedSongsTable
                          // progress= {progress} 
                          // stopUpload = {stopUpload}
                          // uploadStatus = {uploadStatus}
                          // files = {files}
                          uploadedSongs={uploadedSongs}
                          // stopList={stopList}
                          // isUploading={isLoading}
                          height={{xs: '100px',sm:'85px',md:'100px',lg:'140px', xl:'180px'}}
                          setUploadedSongs={setUploadedSongs}
                        />

                      </Box>
                    
                    <Box height= '100%' className='flex col j-end a-end'>
                      <CheckIcon  color={theme.palette.primary.main === ('#00d744' || '#00D744') ? '#00d744' :  getContrastRatio('#08231B', theme.palette.primary.main) > 4.5 ? `${theme.palette.primary.main}` : generateLighterContrastColor(theme.palette.primary.main)} 
                      onClick={()=> handleClose()}  
                      sx={{fontSize:{xs:'28px !important',sm:'30px !important',md:'42px !important', lg:'56px !important',xl:'75px !important'}, cursor: 'pointer'}}/>
                    </Box>
                </Box>
              </Box>

          </Box>
      </Box>
   
    </CustomAlert>

  )
}

export default ViewSongsPopup